import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchPlaybookSection } from "../../../services/automapOperationsPlaybookApi";
import {
  CopyTemplateButton,
  PlaybookAudienceTags,
  PlaybookShell,
  PlaybookStatusBadge,
  RelatedRouteCards,
  RulesList,
  SectionTableOfContents,
  WorkflowSteps,
} from "./AdminPlaybookShared";

export default function AdminPlaybookSectionPage({ slug: slugProp }) {
  const { sectionSlug: paramSlug } = useParams();
  const slug = slugProp || paramSlug;
  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setError("");
    fetchPlaybookSection(slug)
      .then((data) => setSection(data.section))
      .catch((err) => setError(err.message || "Sección no encontrada."))
      .finally(() => setLoading(false));
  }, [slug]);

  const navActive = slug || "hub";

  return (
    <PlaybookShell
      active={navActive}
      title={section?.title || "Playbook"}
      description={section?.summary}
      viewEvent="operations_playbook_section_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? (
        <div className="dealer-state-box">
          <p>{error}</p>
          <Link to="/admin/playbook">Volver al hub</Link>
        </div>
      ) : null}

      {!loading && section ? (
        <div className="admin-playbook__layout">
          <div className="admin-playbook__main">
            <header className="dealer-state-box">
              <div className="admin-playbook__header-row">
                <PlaybookStatusBadge status={section.status} />
                <span className="muted">Actualizado: {section.updatedAt?.slice(0, 10)}</span>
              </div>
              <PlaybookAudienceTags audience={section.audience} />
            </header>

            <section id="playbook-when" className="dealer-state-box">
              <h3>Cuándo usar</h3>
              <p>{section.whenToUse}</p>
            </section>

            <div id="playbook-workflow">
              <WorkflowSteps workflow={section.workflow} />
            </div>

            {section.checklists?.length ? (
              <section id="playbook-checklists" className="dealer-state-box">
                <h3>Checklists relacionados</h3>
                <ul>
                  {section.checklists.map((c) => (
                    <li key={c.id}>
                      <Link to={`/admin/playbook/checklists?checklist=${c.id}`}>{c.title}</Link>
                      <span className="muted"> · {c.recurrence}</span>
                    </li>
                  ))}
                </ul>
              </section>
            ) : null}

            {section.templates?.length ? (
              <section id="playbook-templates">
                <h3 className="admin-playbook__section-title">Plantillas de mensaje</h3>
                {section.templates.map((t) => (
                  <CopyTemplateButton key={t.id} templateId={t.id} label={t.title} text={t.body} />
                ))}
              </section>
            ) : null}

            <div id="playbook-rules">
              <RulesList title="Reglas de decisión" rules={section.decisionRules} />
              <RulesList title="Escalación" rules={section.escalationRules} />
            </div>

            {section.relatedMetrics?.length ? (
              <section className="dealer-state-box">
                <h3>Métricas relacionadas</h3>
                <ul className="dashboard-checklist">
                  {section.relatedMetrics.map((m) => (
                    <li key={m}>{m}</li>
                  ))}
                </ul>
              </section>
            ) : null}

            {section.relatedSections?.length ? (
              <section className="dealer-state-box">
                <h3>Secciones relacionadas</h3>
                <ul>
                  {section.relatedSections.map((s) => (
                    <li key={s.slug}>
                      <Link to={`/admin/playbook/${s.slug}`}>{s.title}</Link>
                    </li>
                  ))}
                </ul>
              </section>
            ) : null}

            <div id="playbook-routes">
              <RelatedRouteCards routes={section.relatedRoutes} sectionSlug={section.slug} />
            </div>
          </div>

          <aside className="admin-playbook__sidebar">
            <SectionTableOfContents section={section} />
          </aside>
        </div>
      ) : null}
    </PlaybookShell>
  );
}
